export * from './lib/qa-attribute-widget.module';
